export * from './configuration_alerting_actions_detail.component';
